import { createSlice } from "@reduxjs/toolkit";

export const customerFeedbackSlice = createSlice({
  name: "customerFeedback",
  initialState: {
    feedbackQuestions: [],
    isUpdateFeedbackQuestionResponse: false,
    isFeedbackError: false,
    singleLeadFeedback: [],
  },

  reducers: {
    getFeedbackQuestionAction: (state) => {},
    setFeedbackQuestionAction: (state, { payload }) => {
      console.log("payload", payload);
      // const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.feedbackQuestions = payload;
    },

    updateFeedbackQuestionAction: (state, { payload }) => {},
    setUpdateFeedbackQuestionAction: (state, { payload }) => {
      state.isUpdateFeedbackQuestionResponse = payload;
    },
  },
});

const {
  getFeedbackQuestionAction,
  setFeedbackQuestionAction,
  updateFeedbackQuestionAction,
  setUpdateFeedbackQuestionAction,
} = customerFeedbackSlice.actions;

export {
  getFeedbackQuestionAction,
  setFeedbackQuestionAction,
  updateFeedbackQuestionAction,
  setUpdateFeedbackQuestionAction,
};

export default customerFeedbackSlice.reducer;
